import { render } from "./CultureList.vue?vue&type=template&id=b047fcf6&scoped=true"
import script from "./CultureList.vue?vue&type=script&lang=js"
export * from "./CultureList.vue?vue&type=script&lang=js"

import "./CultureList.vue?vue&type=style&index=0&id=b047fcf6&lang=scss&scoped=true"

import exportComponent from "E:\\_www\\gxwhcy\\view\\index\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b047fcf6"]])

export default __exports__